<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref="form"
          >
            <el-form-item
              label="渠道名称"
              prop="channel"
            >
              <el-input
                v-model="form.channel"
                placeholder="请选择"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="渠道编码"
              prop="channelCode"
            >
              <el-input
                v-model="form.channelCode"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="支付币种"
              prop="currency"
            >
              <el-select
                v-model="form.currency"
                placeholder="请选择"
                multiple
              >
                <el-option
                  v-for="(item, index) in currencys"
                  :key="index"
                  :label="item.value"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="渠道协议名称"
              prop="scheme"
            >
              <el-input
                v-model="form.scheme"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="渠道md5key"
              prop="key"
            >
              <el-input
                v-model="form.key"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="渠道商户号"
              prop="merchantId"
            >
              <el-input
                v-model="form.merchantId"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="回调白名单IP" prop="callbackWhitelistIp">
              <el-input v-model="form.callbackWhitelistIp" placeholder="请输入回调白名单IP"></el-input>
            </el-form-item>
            <el-form-item
              label="备注"
             >
              <el-input
                type="textarea"
                row="3"
                resize="none"
                maxlength="20"
                show-word-limit
                v-model="form.remark"
                placeholder="请输入"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
              class="blod-form-item"
            >
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="1"
              >启用</vs-radio>
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class=""
                :vs-value="2"
              >禁用</vs-radio>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import { createChannel,updateChannel } from '@/api/channel'
  import { getDictListByType } from '@/api/user'
  import { validateIpWhitelist } from '@/utils/validate'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
      name: "editOrAdd",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        editData:{
          type: Object,
          default(){
            return {
              name: '',
              product: '',
              status: 1,
            }
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          form:{
            id: 1,
            channel: '',
            channelCode : '',
            currency: [],
            scheme: '',
            key: '',
            merchantId: '',
            callbackWhitelistIp: '',
            remark: '',
            createTime: '',
            status: 1,
          },
          rules:{
            // 名字有长度限制以及不能输入空格
            channel:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            channelCode:[
              { required: true, message: '请输入', trigger: 'blur' }
            ],
            currency:[
              { required: true, message: '请输入', trigger: 'change' }
            ],
            callbackWhitelistIp:[
              {
                validator: (rule, value, callback) => {
                  if (value && !validateIpWhitelist(value)) {
                    callback(new Error('请输入正确的IP格式，多个IP请用英文逗号分隔，不允许有空格'));
                  } else {
                    callback();
                  }
                },
                trigger: 'blur'
              }
            ],
          },
          currencys: [],
        }
      },
      created(){
        this.getCurrencys();
      },
      watch: {
        editData(newValue, oldValue) {
          if(newValue){
            this.form.id = newValue.id;
            this.form.channel = newValue.channelName;
            this.form.channelCode = newValue.channelCode;
            this.form.currency = newValue.supportCurrency.split(',');
            this.form.scheme = newValue.channelProtocolName;
            this.form.key = newValue.channelMerMd5Key;
            this.form.merchantId = newValue.channelMerNo;
            this.form.callbackWhitelistIp = newValue.callbackWhitelistIp || '';
            this.form.status = newValue.channelStatus;
            this.form.remark = newValue.remark || '';
          }else {
            this.form = {
              id: 1,
              channel: '',
              channelCode : '',
              currency: [],
              scheme: '',
              key: '',
              merchantId: '',
              callbackWhitelistIp: '',
              remark: '',
              createTime: '',
              status: 1,
            }
          }
        },
        active(newValue){
          if(newValue){
            this.$refs.form.clearValidate();
          }
        }
      },
      computed: {
        title() {
          return this.isEdit ? '编辑渠道': '添加渠道';
        }
      },
      methods: {
        getCurrencys(){
          getDictListByType({
            type: 'currency'
          }).then((res) => {
            console.log(res);
            this.currencys = res.data;
          })
        },
        close(){
          this.reset();
          this.$emit('close')
        },
        reset(){
          this.form = {
            id: 1,
            channel: '',
            channelCode : '',
            currency: [],
            scheme: '',
            key: '',
            merchantId: '',
            callbackWhitelistIp: '',
            remark: '',
            createTime: '',
            status: 1,
          };
        },
        closeHandle() {
          this.close();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                // ajax
                let params = {
                  channelName: this.form.channel,
                  channelCode: this.form.channelCode,
                  supportCurrency: this.form.currency.join(','),
                  channelProtocolName: this.form.scheme,
                  channelMerMd5Key: this.form.key,
                  channelMerNo: this.form.merchantId,
                  callbackWhitelistIp: this.form.callbackWhitelistIp,
                  channelStatus: this.form.status,
                }
                if(this.form.remark){
                  params.remark = this.form.remark;
                }
                if(this.isEdit){
                  params.id = this.form.id;
                  updateChannel(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  })
                }else {
                  createChannel(params).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  })
                }
              }else {

              }
            })
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
